/**
 * On Nuxt ready hook
 * @https://nuxt.com/docs/api/utils/on-nuxt-ready
 */
import Console from '~/utils/lib/core/console'

const console = new Console('plugin:ready')

export default defineNuxtPlugin(() => {
  console.log('ready made')
  /// Here one can place vendor executions running after the application has
  // finished initializing
})
